import { render } from "./Get2FaCode.vue?vue&type=template&id=680605ef"
import script from "./Get2FaCode.vue?vue&type=script&lang=js"
export * from "./Get2FaCode.vue?vue&type=script&lang=js"

import "./Get2FaCode.vue?vue&type=style&index=0&id=680605ef&lang=scss&restr=true"

import exportComponent from "C:\\agent\\_work\\82\\s\\SimpleSums\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__